import {
  selectUI,
  textUI,
  titleUI,
} from 'platform/forms-system/src/js/web-component-patterns';
import FieldsetLabel from '../../../components/FormDescriptions/FieldsetLabel';
import content from '../../../locales/en/content.json';
import { FULL_SCHEMA, STATES_50_AND_DC } from '../../../utils/imports';

const TITLE_TEXT = content['vet-info--birthplace-title'];
const DESC_TEXT = content['vet-info--birthplace-description'];
const FIELDSET_LABEL = content['vet-info--birthplace-label'];
const INPUT_LABELS = {
  city: content['vet-info--birthplace-city-label'],
  state: content['vet-info--birthplace-state-label'],
};

const { cityOfBirth, stateOfBirth } = FULL_SCHEMA.properties;
const STATE_LABELS = {
  ...STATES_50_AND_DC.reduce((acc, { label, value }) => {
    acc[value] = label;
    return acc;
  }, {}),
  Other: 'Other',
};

export default {
  uiSchema: {
    ...titleUI(TITLE_TEXT, DESC_TEXT),
    'view:placeOfBirth': {
      'ui:title': FieldsetLabel(FIELDSET_LABEL),
      cityOfBirth: textUI(INPUT_LABELS.city),
      stateOfBirth: selectUI({
        title: INPUT_LABELS.state,
        labels: STATE_LABELS,
      }),
    },
  },
  schema: {
    type: 'object',
    properties: {
      'view:placeOfBirth': {
        type: 'object',
        properties: { cityOfBirth, stateOfBirth },
      },
    },
  },
};
